import React from "react";
import { useState,useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/ReferrerLog.css';
import { configData } from "../config";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const CashLog = () => {

        const headers = [
        "Created Date",
        "Description",
        "Amount Paid",
        "Updated By"
    ];

    const rowData =[
        {   
            createdDate: "2025-05-28 15:02:35", 
            description: "Amount Paid By 375837", 
            amountPaid: "$100", 
            updatedBy: "premiersportsdc@gmail.com"
        }
    ];
    var {drupaluid} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [referrerlog, setReferrerLog] = useState(true);
     const [mail, setMail] = useState('');
    const app_url = configData.APP_URL;
     async function getreferrerlog(drupaluid) {
        try {
            const response = await fetch(
                app_url+'referralreport/getreferrerlog?drupaluid='+drupaluid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setReferrerLog(responsedata.data.result);
                setMail(responsedata.data.email);
               
            } 
        } catch (err) {
            
        }    
    }
    useEffect(() => { 
        Promise.all([
            getreferrerlog(drupaluid)
            ]).then(() => {
     
                setIsLoading(false);
            })   
    },[]); 

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet><title>Cash Log</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="cash-log-container">
                            <div className="page-view-myorder">
                                <div className="panel panel-default">
                                    <div style={{fontWeight:"bold", borderBottom:"1px solid #ddd"}}>
                                        <div style={{padding: "5px 15px"}}>Referral Log for {mail}</div>
                                    </div>
                                    <div className="panel-body">
                                        <table className="table table-bordered table-striped cash-log-table">
                                            <thead>
                                                <tr>
                                                    {headers.map((header, index) => (
                                                        <th style={{fontWeight:"bold"}} key={index}>{header}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {referrerlog.length > 0 && (
                                                    <>
                                                {referrerlog.map((row, idx) => (
                                                    <tr key={idx}>
                                                        <td>{row.createdDate}</td>
                                                        <td>{row.description}</td>
                                                        <td style={{width: "14%"}}>{row.amountPaid}</td>
                                                        <td style={{width: "30%"}}>{row.updatedBy}</td>
                                                    </tr>
                                                ))}
                                                </>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )} 
        </>
    );
};
export default CashLog;